$(document).ready(function () {
	$('.knowledge-hub').each(function () {
		var $section = $(this);

		// the browser's "x" in the search field fires a "search" event with an empty value:
		// resubmit so an active search is cleared and every post is listed again
		$section.find('.knowledge-hub__search-form input[name="q"]').on('search', function () {
			if (this.value === '' && this.defaultValue !== '') {
				this.form.submit();
			}
		});

		// a search with no results renders the section without a slider
		if ($section.find('.knowledge-hub__slider').length === 0) { return; }

		new Swiper($section.find('.knowledge-hub__slider')[0], {
			slidesPerView: 1,
			spaceBetween: 40,
			speed: 700,
			autoHeight: true,
			pagination: {
				el: $section.find('.knowledge-hub__pagination')[0],
				clickable: true,
			},
		});
	});
});



// WEBPACK FOOTER //
// ./resources/js/modules/knowledge-hub.js